import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// this entire thing is a temp replacement for C.logger.doSessionLog, need to replace usages of this with rio-sdk-web
export default {
  event: function () {
    var _event = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(envUrl, pageTrackId, logContent) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _objectSpread(_objectSpread({}, logContent), {}, {
                page_track_id: pageTrackId,
                destination_url: window.location.href,
                referrer_url: document.referrer
              });

              try {
                fetch("".concat(envUrl, "_ajax/log/session"), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(data)
                });
              } catch (e) {
                // existing session logger does a simple console log when it fails,
                // we follow the same behavior here but use console.error as a web.dev best practice
                // https://web.dev/errors-in-console/
                // https://github.com/GoogleChrome/lighthouse/blob/v5.6.0/lighthouse-core/audits/errors-in-console.js#L89
                console.error("session log failed with error: ".concat(e.message));
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function event(_x, _x2, _x3) {
      return _event.apply(this, arguments);
    }

    return event;
  }()
};